import React, { useState } from "react";
import { BASE_URL, API_ROOT } from "../../../../baseUrls";
import { connect } from "react-redux";
import {
  Container,
  Box,
  Typography,
  Grid,
  TextareaAutosize,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  Button,
} from "@material-ui/core";
import Loader from "../../../organisms/loader/Loader";
import AvatarWaitTimer from "../../../organisms/loader/AvatarWaitTimer";

function Share({ user, mindfile, mindfileId, avatarReady }) {
  const [embedSize, setEmbedSize] = useState("1");
  const [emailTo, setEmailTo] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailStatus, setEmailStatus] = useState("not_sent");

  if (!avatarReady) {
    return <AvatarWaitTimer />;
  }

  const embedImgUrl = () => {
    switch (parseInt(embedSize)) {
      case 1:
        return `${BASE_URL}/images/widget/embed_avatar_size1.jpg`;
      case 2:
        return `${BASE_URL}/images/widget/embed_avatar_size2.jpg`;
      case 3:
        return `${BASE_URL}/images/widget/embed_avatar_size3.jpg`;
      default:
        return "";
    }
  };

  const embedSizeToDimensions = (size) => {
    switch (parseInt(size)) {
      case 1:
        return "160x440";
      case 2:
        return "320x560";
      case 3:
        return "480x720";
      default:
        return "";
    }
  };

  const sendEmail = () => {
    const formData = new FormData();
    formData.append("to", emailTo);
    formData.append("message", emailMessage);
    // formData.append("authenticity_token", user.authenticity_token);

    setEmailStatus("sending");
    fetch(`${API_ROOT}/mindfiles/${mindfileId}/avatar/email`, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
      .then(resp => resp.text())
      .then(() => {
        setEmailStatus("sent");
      })
      .catch(() => {
        setEmailStatus("error");
      });
  };

  const renderEmailForm = () => {
    switch (emailStatus) {
      case "sending":
        return <Loader />;
      case "sent":
        return <Typography variant="h5">Email sent.</Typography>;
      case "error":
        return (
          <Typography>There was an error trying to send your email.</Typography>
        );
      case "not_sent":
        return (
          <Box>
            <Typography variant="h5">Email</Typography>
            <Box mt={1}>
              <TextField
                size="small"
                variant="outlined"
                label="To"
                value={emailTo}
                onChange={e => setEmailTo(e.target.value)}
                style={{ width: "100%", maxWidth: 300 }}
              />
            </Box>
            <Box mt={1}>
              <TextField
                size="small"
                multiline
                minRows={3}
                variant="outlined"
                label="Message"
                value={emailMessage}
                onChange={e => setEmailMessage(e.target.value)}
                style={{ width: "100%", maxWidth: 300 }}
              />
            </Box>
            <Box mt={1}>Preview</Box>
            <Box
              mt={1}
              position="relative  "
              style={{ width: 310, height: 216 }}
            >
              <img src={`${BASE_URL}/images/email_avatar.jpg`} alt="Preview" />
              <img
                src={`${API_ROOT}/mindfiles/${mindfileId}/avatar/thumbnail?size=73&ts=${mindfile.timestamp}`}
                alt="mini me"
                style={{
                  position: "absolute",
                  top: 64,
                  left: 142,
                  width: 73,
                  height: 73,
                }}
              />
            </Box>
            <Box mt={1}>
              <Button color="primary" variant="contained" onClick={sendEmail}>
                Send
              </Button>
            </Box>
          </Box>
        );
      default:
        return null;
    }
  };

  return (
    <Container>
      <Box mt={5}>
        <Typography variant="h4">Share</Typography>
      </Box>
      <Box mt={3} mb={3}>
        <Typography>Choose how you would like to share your avatar:</Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          {renderEmailForm()}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h5">Embed</Typography>
          <Box style={{marginTop: "1rem"}}>
            <Typography>Choose the size you would like:</Typography>
          </Box>
          <RadioGroup
            row
            value={embedSize}
            onChange={e => setEmbedSize(e.target.value)}
          >
            <FormControlLabel value="1" control={<Radio />} label={embedSizeToDimensions("1")} />
            <FormControlLabel value="2" control={<Radio />} label={embedSizeToDimensions("2")} />
            <FormControlLabel value="3" control={<Radio />} label={embedSizeToDimensions("3")} />
          </RadioGroup>
          <Box style={{marginTop: "1rem", marginBottom: "1rem"}}>
            <img src={embedImgUrl()} alt="Embedded avatar" />
          </Box>
          <Typography>
            Copy and paste the code below into your website or blog to have your
            live, talking LifeNaut avatar there in your site:
          </Typography>
          <TextareaAutosize
            minRows={3}
            value={`<script src="${API_ROOT}/avatar.js?mindfile=${mindfileId}&size=${embedSizeToDimensions(embedSize)}"></script>`}
            style={{ width: "100%", marginTop: 16 }}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

const mapStateToProps = state => ({
  user: state.auth,
  mindfile: state.mindfile,
  mindfileId: state.mindfile.id,
  avatarReady: !state.avatarReadyAt,
});

export default connect(mapStateToProps)(Share);
